(function(){function peek(){if(window.innerWidth>749)return;var s=document.querySelector('.cmpg__scroll');if(!s)return;var g=s.querySelector('.cmpg__grid');if(!g)return;if(s.scrollWidth<=s.clientWidth+4)return;if(s.scrollLeft>0)return;var f=parseFloat(getComputedStyle(g).gridTemplateColumns.split(' ')[0]);if(!f)return;s.scrollLeft=Math.round(f/2);}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peek);}else{peek();}window.addEventListener('load',peek);})();
$('.all-reviews').slick({
    centerMode:true,
    slidesToShow:5,
    autoplay:true,
    arrows: false,
    dots:true,
    centerPadding:'0px',
    infinite: true,
    responsive:[
        {
          breakpoint: 768,
          settings: {
            centerPadding: '0px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
    ]
});

$('.toggle-title h2').click(function(e){
  e.preventDefault();
  $('.single-questions').not($(this).parents('.single-questions')).removeClass('active');
  $(this).parents('.single-questions').toggleClass('active');
});
$('.acc-title').click(function(e){
  e.preventDefault();
  $('.acc-link').removeClass('open');
  $(this).parent('.acc-link').addClass('open');
});
var medias = Array.prototype.slice.apply(document.querySelectorAll('audio,video')).filter(function(m){ return !m.closest('.ugc__media'); });
medias.forEach(function(media) {
  media.addEventListener('play', function(event) {
    medias.forEach(function(media) {
      if(event.target != media) media.pause();
    });
  });
});


// external js: isotope.pkgd.js

$('.grid-testi').isotope({
  itemSelector: '.testi-item',
  masonry: {
    columnWidth: '.testi-item'
  }
});
$('.border-main-top .video_tile').click(function() {
  var vidoe = $(this).parent('.left-images').find('video');
  console.log(vidoe);
  if(vidoe.length != 0 ){
    vidoe[0].paused ? vidoe[0].play() : vidoe[0].pause();
  }
  
  var iframes = $(this).parent('.left-images').find('iframe');
  if(iframes.length != 0){
    iframes[0].src += "&autoplay=1";
  }
});

$('.button-textnaim').click(function(e){
  $(this).parent('.video-section__media').find('button').trigger('click');
});
$('.video_tile').click(function(e){
  $(this).parent('.video-section__medias').find('button').trigger('click');
});

function getYoutubeID(url){
    var i, r, rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    r = url.match(rx);
    i = r[1];
    return i;
}

var youtube = document.querySelectorAll( ".cvideo-area" );
  
for (var i = 0; i < youtube.length; i++) {
    var souce = youtube[i].dataset.video;
    var ID = getYoutubeID(souce);
    var source = "https://img.youtube.com/vi/"+ ID +"/0.jpg";
    //https://img.youtube.com/vi/bJKRhsmrsBM/0.jpg
    
    // var image = new Image();
    //         image.src = source;
    //         image.addEventListener( "load", function() {
    //             youtube[ i ].appendChild( image );
    //         }( i ) );
    
    youtube[i].addEventListener( "click", function(datas) {
    window.pauseAllMedia();
         
        var souce = this.dataset.video;
        var ID = getYoutubeID(souce);
        var iframe = document.createElement( "iframe" );
        iframe.setAttribute( "frameborder", "0" );
        iframe.setAttribute( "allowfullscreen", "" );
        iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ ID +"?rel=0&showinfo=0&autoplay=1&enablejsapi=1" );
        this.innerHTML = "";
        this.appendChild( iframe );
      console.log(this);
      const childdev = this.querySelector('iframe');
      console.log(childdev);
      
        iframe.play();
    } );    
};
